import { createSlice } from '@reduxjs/toolkit'
import jwtDecoder from '../../../utils/jwtDecoder'
const initialState = {
  info: null,
  isSessionExpired: false,
}
const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      const accessToken = action?.payload?.accessToken

      if (typeof accessToken !== 'string' || !accessToken.trim()) {
        console.warn('No valid access token provided')
        state.info = null
        return
      }

      try {
        const decodedJwt = jwtDecoder(accessToken)
        state.info = {
          accessToken,
          email: decodedJwt.sub || '',
          roles: decodedJwt.roles || '',
          issuedAt: decodedJwt.iat || '',
          expiresAt: decodedJwt.exp || '',
          firstName: decodedJwt.firstName || '',
          lastName: decodedJwt.lastName || '',
        }
      } catch (error) {
        console.error('Invalid JWT:', error.message)
        state.info = null
      } finally {
        state.isSessionExpired = false
      }
    },
    setReAuthToken: (state, action) => {
      if (state.info) {
        state.info.accessToken = action.payload
      }
    },
    clearUser: (state, action) => {
      state.info = null
    },
    expireUserSession: (state) => {
      state.isSessionExpired = true
    },
    updateUser: (state, action) => {
      let updatedUserInfo = {
        accessToken: state.info?.accessToken,
        firstName: action.payload?.firstName,
        lastName: action.payload?.lastName,
        email: action.payload?.email,
        phone: action.payload?.phone,
        address: action.payload?.address,
        deliveryAddress: action.payload?.deliveryAddress,
      }
      state.info = updatedUserInfo
    },
  },
})

export const {
  setUser,
  setReAuthToken,
  clearUser,
  updateUser,
  expireUserSession,
} = userSlice.actions
export default userSlice.reducer
